/**
 * Demo shelf locations — AA-00 grid. Covers a sample of products across
 * different zones (A = front shelves, B = back room, C = cold storage).
 */
export function buildEmplacements(produits) {
  const out = [];
  let i = 1;
  const zones = ["A", "B", "C"];
  for (const prod of produits.slice(0, 30)) {
    const zone = zones[i % zones.length];
    const code = `${zone}${i % 9}-${String(i).padStart(2, "0")}`;
    out.push({
      id: `emp-${String(i).padStart(3, "0")}`,
      produit_id: prod.id,
      code,
      zone,
      quantite: Math.max(1, Math.floor((prod.stock_actuel || 10) / 2)),
      numero_lot: null,
      notes: "",
      created_at: "2024-04-15T09:00:00.000Z",
    });
    i += 1;
  }
  return out;
}
